import React from 'react';
import classes from "./SubLayout.module.css";

const SubLayout = ({ children ,style}) => {
    return (
        <div className={classes.container} style={style}>
            {children}
        </div>
    )
}

export default SubLayout